import { json2csv } from 'json-2-csv';

import { DEFAULT_CSV_SEPARATOR } from 'constants/csv.const';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import isEmptyObject from 'utils/predicates/object/isEmptyObject.util';

import fromAnyToString from './fromAnyToString';

const L = logger('CSV'); // eslint-disable-line no-unused-vars

export const escapeCsvField = (options) => {
  const value = fromAnyToString(options?.value);
  const separator = options?.separator;

  if (value.includes(separator)) {
    return `"${value}"`; // wrap in quotes if value contains the separator
  }
  return value;
};

export const fromHeadersToString = (options) => {
  try {
    const headers = options?.headers;
    const separator = options?.separator;

    const isArray = Array.isArray(headers);
    if (!isArray) return { value: '', isArray };

    const isFull = isFullArray(headers);
    if (!isFull) return { value: '', isArray, isFull };

    const value = headers.map((header) => escapeCsvField({ value: header, separator })).join(separator);

    return { value, isArray, isFull };
  } catch (error) {
    L.warn('fromHeadersToString()', error);
    return { value: '', error };
  }
};

export const fromDataToCsv = (options) => {
  try {
    const data = options?.data;
    const separator = options?.separator ?? DEFAULT_CSV_SEPARATOR;
    const header = fromHeadersToString({ headers: options?.headers, separator }).value;

    if (!options || isEmptyObject(options)) {
      return { value: '' };
    }

    if (header && !data) {
      return { value: header };
    }

    const isString = typeof data === 'string' && data.trim().length > 0;
    if (isString) {
      return { value: header ? `${header}\r\n${data}` : data, isString };
    }

    const isArray = Array.isArray(data);
    if (!isArray) return { value: '', isArray };

    const value = json2csv(data, {
      delimiter: { field: separator },
    });

    return { value, isArray, isString };
  } catch (error) {
    L.warn('fromDataToCsv()', error);
    return { value: '', error };
  }
};

export const exportCSV = (options) => {
  try {
    const csv = fromDataToCsv({ data: options.data, headers: options.headers, separator: options.separator });

    const BOM = '\uFEFF';

    const blob = new Blob([BOM + csv.value], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = options.fileName;

    document.body.appendChild(link);
    link.click();

    link?.parentNode?.removeChild(link);
  } catch (error) {
    L.warn('exportCSV()', error);
    return false;
  }
};
